import PropTypes from 'prop-types'

/**
 * @typedef {Object} ElectricNotificationsBatteryLevelBasedConfig
 *
 * @property {number} batteryThreshold - The battery threshold value for this notification
 * @property {boolean} enabled - Whether this notification is enabled
 * @property {string} eventLevel - The event level for this notification
 */
export const electricNotificationsBatteryLevelBasedConfigPropType = PropTypes.shape({
    batteryThreshold: PropTypes.number.isRequired,
    enabled: PropTypes.bool.isRequired,
    eventLevel: PropTypes.string.isRequired
})
